module.exports = __webpack_public_path__ + "static/media/AR_plain_no_letters.a0a49e4f.png";